import React from "react";
import "./style.scss";
import { Spinner } from "react-bootstrap";

const CommonButton = ({
  variant,
  onClick,
  isLoading,
  btnText,
  fontWeight = "700",
  applybtnDisable,
  disabled,
}) => {
  const className = `common-button ${variant} font-weight-${fontWeight} ${
    variant === "tertiary" ? "" : "cus-width-height"
  } ${disabled || applybtnDisable ? "disabled-btn" : ""}`;

  return (
    <button
      className={className}
      onClick={isLoading || disabled || applybtnDisable ? null : onClick}
      disabled={isLoading || applybtnDisable || disabled}
    >
      {isLoading ? (
        <Spinner animation="border" size="sm" />
      ) : (
        <span className="uppercase">{btnText}</span>
      )}
    </button>
  );
};

export default CommonButton;
